import { render, staticRenderFns } from "./mytipofday.vue?vue&type=template&id=b2003dce&scoped=true&"
import script from "./mytipofday.vue?vue&type=script&lang=js&"
export * from "./mytipofday.vue?vue&type=script&lang=js&"
import style0 from "./mytipofday.vue?vue&type=style&index=0&id=b2003dce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2003dce",
  null
  
)

export default component.exports